"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onWhatsAppClick = exports.onTwitterClick = exports.onLinkedInClick = exports.onFacebookClick = void 0;
const onFacebookClick = ({ postUrl }) => {
    window.open('https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(postUrl), "_blank");
};
exports.onFacebookClick = onFacebookClick;
const onLinkedInClick = ({ postUrl }) => {
    window.open("https://www.linkedin.com/shareArticle?url=" +
        encodeURIComponent(postUrl), "_blank");
};
exports.onLinkedInClick = onLinkedInClick;
const onTwitterClick = ({ postUrl }) => {
    window.open("https://twitter.com/intent/tweet?url=" +
        encodeURIComponent(postUrl), "_blank");
};
exports.onTwitterClick = onTwitterClick;
const onWhatsAppClick = ({ postUrl }) => {
    window.open(`https://wa.me/?text=${postUrl}`);
};
exports.onWhatsAppClick = onWhatsAppClick;
//# sourceMappingURL=social-share-widget.helpers.js.map